import {
  faBold,
  faItalic,
  faStrikethrough,
  faUnderline,
} from '@fortawesome/pro-regular-svg-icons';
import { ToolbarButton, ToolbarButtonIcon } from './components';
import { ToolBarItemProps } from './types';

export const BoldButton = ({
  editor,
  afterCommandExecuted,
}: ToolBarItemProps) => {
  return (
    <ToolbarButton
      aria-label="Bold"
      pressed={editor.isActive('bold')}
      variant="icon"
      leftIcon={<ToolbarButtonIcon icon={faBold} />}
      onMouseDown={(e) => e.preventDefault()}
      onClick={() => {
        editor.chain().focus().toggleBold().run();
        afterCommandExecuted?.();
      }}
    />
  );
};

export const ItalicButton = ({
  editor,
  afterCommandExecuted,
}: ToolBarItemProps) => {
  return (
    <ToolbarButton
      aria-label="Italic"
      pressed={editor.isActive('italic')}
      variant="icon"
      leftIcon={<ToolbarButtonIcon icon={faItalic} />}
      onMouseDown={(e) => e.preventDefault()}
      onClick={() => {
        editor.chain().focus().toggleItalic().run();
        afterCommandExecuted?.();
      }}
    />
  );
};

export const UnderlineButton = ({
  editor,
  afterCommandExecuted,
}: ToolBarItemProps) => {
  return (
    <ToolbarButton
      aria-label="Underline"
      pressed={editor.isActive('underline')}
      variant="icon"
      leftIcon={<ToolbarButtonIcon icon={faUnderline} />}
      onMouseDown={(e) => e.preventDefault()}
      onClick={() => {
        editor.chain().focus().toggleUnderline().run();
        afterCommandExecuted?.();
      }}
    />
  );
};

export const StrikethroughButton = ({
  editor,
  afterCommandExecuted,
}: ToolBarItemProps) => {
  return (
    <ToolbarButton
      aria-label="Strikethrough"
      pressed={editor.isActive('strike')}
      variant="icon"
      leftIcon={<ToolbarButtonIcon icon={faStrikethrough} />}
      onMouseDown={(e) => e.preventDefault()}
      onClick={() => {
        editor.chain().focus().toggleStrike().run();
        afterCommandExecuted?.();
      }}
    />
  );
};
